<template>
  <div style="padding: 1vw">
    <!-- 검사 모드(W6 A1): 배포 없이 바꾸는 새 검사 스위치. 아래 화이트리스트·공용 비밀번호 스위치는 정리 배포까지 그대로 -->
    <security-modes-card class="mb-4" />
    <consent-bulk-card class="mb-4" />
    <div style="display: flex; justify-content: space-between; align-items: flex-end; padding: 0 1vw">
      <div class="pageTitle">
        <h3 class="fw-bold" style="color: #000; font-size: 1.8rem">
          화이트리스트 관리
        </h3>
        <span class="pageDesc">
          화이트리스트를 등록하고 관리할 수 있습니다.
        </span>
      </div>
      <div style="display: flex; align-items: center; margin-bottom: 1vw;">
        <span style="margin-right: 10px;">비번 점검 여부 체크 (꺼져있으면 서티라이프 관리자 비밀번호로 로그인가능) </span>
        <!-- 서버가 ops.security.manage 지정자만 받음(@PermStrict) — 없으면 바꿀 수 없게(10-30) -->
        <a-switch v-model:checked="pwChecked" :disabled="!canSecurity" @change="setPwCheckedByWhitelist"/>
      </div>
    </div>
    <div class="container-wrapper">
      <a-table 
        class="ant-table-striped"
        size="small"
        v-if="responseData"
        :columns="columns"
        :data-source="responseData.whitelistIp"
        :pagination="false"
      >
        <template #emptyText>
          <div class="noResult">검색 결과가 없습니다.</div>
        </template>
      </a-table>
    </div>

    <!-- 지금 유효한 국외 예외·2차 인증 예외(REQ-ACC-012, C7). 제목 여백은 위 페이지 제목과 같게(.pageTitle 기본 여백) -->
    <div style="padding: 2vw 1vw 0">
      <div class="pageTitle">
        <h3 class="fw-bold" style="color: #000; font-size: 1.4rem">
          유효한 보안 예외
        </h3>
        <span class="pageDesc">
          지금 효력이 있는 국외 접속 예외와 2차 인증 예외입니다. 끄거나 해제하려면 행의 「2차 인증」을 누르세요.
        </span>
      </div>
    </div>
    <div class="container-wrapper">
      <a-table
        class="ant-table-striped"
        size="small"
        row-key="_rowKey"
        :columns="exemptionColumns"
        :data-source="exemptions"
        :loading="exemptionsLoading"
        :pagination="false"
      >
        <template #bodyCell="{ column, record }">
          <template v-if="column.key === 'approvedBy'">{{ approver(record.approvedBy) }}</template>
          <!-- 그 계정의 「2차 인증」 창을 바로 연다(M13) -->
          <div
            v-else-if="column.key === 'manage'"
            type="button"
            class="certi-custom-btn"
            style="white-space: nowrap"
            @click="openSecurity(record)"
          >
            2차 인증
          </div>
        </template>
        <template #emptyText>
          <div class="noResult">{{ exemptionsError || "유효한 예외가 없습니다." }}</div>
        </template>
      </a-table>
    </div>

    <account-security-modal :account="securityAccount" @close="closeSecurity" />
  </div>

</template>
<script>
import { oneBtnDialog } from "../../utils/utils";
import { errorCode, errorMessage, formatTime, isStepUpCancelled } from "../../utils/mfa";
import { loadOperatorNames } from "../../utils/operators";
import AccountSecurityModal from "@/views/components/AccountSecurityModal.vue";
import SecurityModesCard from "./SecurityModesCard.vue";
import ConsentBulkCard from "./ConsentBulkCard.vue";
import { canNow } from "@/utils/perm";

const EXEMPTION_TYPE_LABEL = { geo: "국외 접속", mfa: "2차 인증" };

export default {
  name: "noticesList",
  components: {
    AccountSecurityModal,
    SecurityModesCard,
    ConsentBulkCard,
  },
  data() {
    return {
      // 목록 받아오는 변수
      responseData: [],  

      targetsList: [], // 노출 대상 받아오기
      condition: "ALL", // 최초 검색필터는 전체

      listSize: 0,
      columns: [
        { key: 'index', title: '번호', dataIndex: 'index', align: 'center',
          customRender: ({ record }) => record.index
        },
        { key: 'ip', title: 'Ip', dataIndex: 'ip', align: 'center',
          customRender: ({ record }) => record.ip
        },
      ],
      pwChecked:false,

      // 유효한 보안 예외 목록(GET /admin/security/exemptions?type=geo|mfa)
      exemptions: [],
      exemptionsLoading: false,
      exemptionsError: "",
      exemptionColumns: [
        { key: 'type', title: '종류', dataIndex: 'type', align: 'center',
          customRender: ({ record }) => EXEMPTION_TYPE_LABEL[record.type] || record.type
        },
        { key: 'companyName', title: '회사', dataIndex: 'companyName', align: 'center' },
        { key: 'username', title: '계정', dataIndex: 'username', align: 'center' },
        { key: 'until', title: '끝 시각', dataIndex: 'until', align: 'center',
          customRender: ({ record }) => formatTime(record.until)
        },
        { key: 'reason', title: '사유', dataIndex: 'reason' },
        { key: 'approvedBy', title: '승인 운영자', dataIndex: 'approvedBy', align: 'center' },
        { key: 'manage', title: '관리', align: 'center', width: 90 },
      ],
      // 승인 운영자 id → 이름(아이디)(M1)
      operatorNames: {},
      securityAccount: null, // 「2차 인증」 창을 연 예외 행
    };
  },
  
  async mounted() {
    this.getExemptions();
    loadOperatorNames().then((names) => (this.operatorNames = names));
    await this.getWhitelist();
  },
  computed: {
    canSecurity() {
      return canNow(this.$store.state.introspect, "ops.security.manage");
    },
  },
  methods: {
    approver(id) {
      return this.operatorNames[id] || id || "-";
    },
    openSecurity(row) {
      this.securityAccount = { _id: row.accountId, corpName: row.companyName, username: row.username };
    },
    // 창에서 예외를 끄거나 바꿨을 수 있으니 닫으면 다시 읽는다
    closeSecurity() {
      this.securityAccount = null;
      this.getExemptions();
    },
    // 노출 대상 가져오기
    async getWhitelist() {
      try {
        const response = await this.$apiInstance.get(`/auth/whitelist`);
        console.log(response)
        if(response.status === 200 || response.status === 201) {
          let index = 0;
          this.pwChecked = response.data.pwChecked == 'Y' ? true : false;
          this.responseData = {
            ...response.data,
            whitelistIp:
              response.data.whitelistIp.map(o=>{
                index++;
                return {
                  index,
                  ip:o
                }
              })
          };
        } 
      } catch (error) {
        console.log(error);
      }
    },
    async getExemptions() {
      this.exemptionsLoading = true;
      this.exemptionsError = "";
      try {
        const lists = await Promise.all(
          ["geo", "mfa"].map((type) =>
            this.$apiInstance
              .get(`/admin/security/exemptions`, { params: { type }, showGlobalLoading: false })
              .then((response) => response.data || [])
          )
        );
        this.exemptions = lists.flat().map((item, index) => ({ ...item, _rowKey: index }));
      } catch (error) {
        console.log(error);
        this.exemptions = [];
        this.exemptionsError = errorMessage(error, "예외 목록을 불러오지 못했습니다. 잠시 뒤 다시 열어 주세요.");
      } finally {
        this.exemptionsLoading = false;
      }
    },
    async setPwCheckedByWhitelist() {
      try {
        console.log(this.pwChecked)
        const pwChecked = {
          pwChecked:this.pwChecked === true ? 'Y' : 'N'
        }
        const response = await this.$apiInstance.post(`/auth/whitelist/pwChecked`,pwChecked);
        console.log(response)
        if(response.status === 200 || response.status === 201) {
          this.pwChecked = response.data.pwChecked == 'Y' ? true : false;
        }
      } catch (error) {
        console.log(error);
        // 실패하면 스위치를 원래대로 돌리고 이유를 보여 준다(400 외에 403 MFA_REQUIRED 등도).
        // GEO_BLOCKED 는 axios 인터셉터가 같은 문구를 이미 알렸고, 본인 확인을 스스로 취소했으면 알리지 않는다(M12·D5)
        this.pwChecked = !this.pwChecked;
        if (errorCode(error) === "GEO_BLOCKED" || isStepUpCancelled(error)) return;
        await oneBtnDialog('변경 실패', errorMessage(error, '변경하지 못했습니다. 잠시 뒤 다시 시도하세요.'))
      }
    },
  },
};
</script>
